"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _toolkit = require('@reduxjs/toolkit');






var _common = require('shared/selectors/blobject/common/common');
var _peers = require('shared/selectors/peers');
var _org = require('shared/selectors/org');
var _user = require('shared/selectors/user');
var _entities = require('shared/transforms/entities');

 const RECENT_LIMIT = 3; exports.RECENT_LIMIT = RECENT_LIMIT

 const recentOrgName = (orgKey, orgs) =>
  (orgKey && _optionalChain([orgs, 'optionalAccess', _ => _[orgKey ], 'optionalAccess', _2 => _2.Name])) || ''; exports.recentOrgName = recentOrgName

// "BloomText" for a coworker, "Patient · BloomText" for a patient.
const describeUser = (orgs) => (user) => {
  const [rel] = Object.values(user.Relationships || {})
  return exports.recentOrgName.call(void 0, _optionalChain([rel, 'optionalAccess', _3 => _3.OrgKey]), orgs)
}
const describePatient = (patient, orgs) => {
  const orgName = exports.recentOrgName.call(void 0, patient.OrgKey, orgs || {})
  return orgName ? `Patient · ${orgName}` : 'Patient'
}

const bySortTimeDesc = (a, b) =>
  (b.InboxSortTime || '').localeCompare(a.InboxSortTime || '')

/* The New chat's "Recent": the other person in your latest one-to-one chats
 * (a coworker, or a patient), newest first, from the chats already loaded. A
 * staff chat with a team or more than one other person isn't one-to-one; a
 * patient chat is one-to-one with its patient even though it's in a team. */
 const selectRecentChatEntities = _toolkit.createSelector.call(void 0, 
  _common.selectBlobjects, _peers.selectAllUsers, _peers.selectAllPatients, _org.selectOrgs, _user.selectCurrentUserKey,
  (blobjects, users, patients, orgs, myUserKey) => {
    const seen = new Set()
    const recent = []
    const toUserEntity = _entities.mapUserToEntity.call(void 0, orgs , describeUser(orgs ))
    const toPatientEntity = _entities.mapPatientToEntity.call(void 0, orgs , describePatient)
    for (const blobject of Object.values(blobjects).sort(bySortTimeDesc)) {
      if (recent.length >= exports.RECENT_LIMIT) break
      const hasTeam = Object.keys(blobject.TeamSubscribers || {}).length > 0
      const others = Object.keys(blobject.UserSubscribers || {}).filter(key => key !== myUserKey)
      const patientKeys = Object.keys(blobject.PatientSubscribers || {})
      let entity = null
      if (others.length === 1 && !patientKeys.length && !hasTeam) {
        const user = (users )[others[0]]
        if (user) entity = toUserEntity(user)
      } else if (!others.length && patientKeys.length === 1) {
        const patient = (patients )[patientKeys[0]]
        if (patient) entity = toPatientEntity(patient)
      }
      if (!entity || seen.has(entity.entityKey)) continue
      seen.add(entity.entityKey)
      recent.push(entity)
    }
    return recent
  },
); exports.selectRecentChatEntities = selectRecentChatEntities
